import { COMMON_DOCUMENTS } from './documents';
export const AE = {
    code: 'AE',
    name: 'United Arab Emirates',
    profileVersion: 1,
    readiness: 'ready',
    timezone: 'Asia/Dubai',
    weekend: [6, 0],
    firstDayOfWeek: 1,
    currency: { code: 'AED', displayFractionDigits: 2, roundToWholeUnits: false },
    subdivisions: [
        { code: 'AE-AZ', name: 'Abu Dhabi', healthRegulator: 'DOH' },
        { code: 'AE-DU', name: 'Dubai', healthRegulator: 'DHA' },
        { code: 'AE-SH', name: 'Sharjah', healthRegulator: 'MOHAP' },
        { code: 'AE-AJ', name: 'Ajman', healthRegulator: 'MOHAP' },
        { code: 'AE-UQ', name: 'Umm Al Quwain', healthRegulator: 'MOHAP' },
        { code: 'AE-RK', name: 'Ras Al Khaimah', healthRegulator: 'MOHAP' },
        { code: 'AE-FU', name: 'Fujairah', healthRegulator: 'MOHAP' },
    ],
    branchSubdivision: 'required',
    locales: {
        ui: ['en', 'ar'],
        defaultUi: 'en',
        documentSecondary: 'ar',
        secondaryOnTaxDocuments: 'default_on',
        secondaryOnClinicalDocuments: 'default_off',
        formatting: { en: 'en-GB', ar: 'ar-AE-u-nu-latn' },
    },
    phone: { callingCode: '971', trunkPrefix: '0', nationalLengths: [9], mobilePattern: '^5\\d{8}$', example: '0501234567' },
    names: { parts: ['first', 'father', 'last'], labels: { father: 'Father name (optional)' }, askLocalName: true },
    identity: {
        documents: [
            {
                type: 'ae_eid',
                labelKey: 'identity.ae_eid',
                label: 'Emirates ID',
                pattern: '^784\\d{12}$',
                normalise: 'digits',
                checksum: 'luhn',
                onChecksumFail: 'warn',
                onPatternFail: 'refuse',
                example: '784-1990-1234567-1',
            },
            {
                type: 'ae_uid',
                labelKey: 'identity.ae_uid',
                label: 'Unified number (UID)',
                pattern: '^\\d{1,15}$',
                normalise: 'digits',
                checksum: 'none',
                onChecksumFail: 'warn',
                onPatternFail: 'warn',
                example: '123456789',
            },
            ...COMMON_DOCUMENTS,
        ],
        defaultType: 'ae_eid',
        autoDetect: false,
        capture: { hospital: 'optional', lab: 'optional', pharmacy: 'optional' },
        askNationality: true,
        dobCalendars: ['gregory'],
    },
    practitionerRegistries: [
        { code: 'DHA', label: 'DHA licence' },
        { code: 'DOH', label: 'DOH licence' },
        { code: 'MOHAP', label: 'MOHAP licence' },
    ],
    tax: [
        {
            code: 'ae_vat',
            effectiveFrom: '2018-01-01',
            registration: { labelKey: 'tax.ae_trn', label: 'TRN', pattern: '^\\d{15}$', checksum: 'none', onFail: 'warn' },
            companyRegistrationLabelKey: 'tax.ae_trade_licence',
            companyRegistrationLabel: 'Trade licence No.',
            standardRatePct: 5,
            serviceDefaultCategory: 'zero',
            productDefaultCategory: 'standard',
            qr: null,
            citizenRelief: null,
        },
    ],
    eInvoicing: { scheme: 'uae_pint', mandatory: 'dated', fromDate: '2027-01-01', appliesTo: ['hospital', 'lab', 'pharmacy'] },
    addOns: [
        { code: 'eclaimlink', subdivisions: ['AE-DU'], built: false },
        { code: 'shafafiya', subdivisions: ['AE-AZ'], built: false },
        { code: 'riayati', subdivisions: ['AE-SH', 'AE-AJ', 'AE-UQ', 'AE-RK', 'AE-FU'], built: false },
    ],
    feeSplittingDefault: false,
};
//# sourceMappingURL=ae.js.map